/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: BpPasswordFieldWrapper.tsx
 * Project: mle-client
 * Committed last: 2021/11/9 @ 1922
 * ---
 */

import { Field, FieldAttributes }                from 'formik';
import React, { useState }                       from 'react';
import { Button, FormGroup, InputGroup, Intent } from '@blueprintjs/core';

export interface TextFieldWrapperProps {
  name: string;
  label: string;
  required: boolean;
  className?: string;
}

export const BpPasswordFieldWrapper = (props: TextFieldWrapperProps) => {

  const [ showPassword, setShowPassword ] = useState(false);

  const lockButton = (
    <Button
      icon={ showPassword ? 'unlock' : 'lock' }
      intent={ Intent.WARNING }
      minimal={ true }
      onClick={ () => setShowPassword(!showPassword) }
    />
  );

  return (
    <Field type="password" name={ props.name }>
      { ({ field, meta }: FieldAttributes<any>) => (
        <FormGroup
          className={ props.className }
          helperText={ meta.touched && meta.error ?
                       <div>{ meta.error }</div> : '' }
          intent={ meta.touched && meta.error ? 'danger' : 'none' }
          label={ props.label }
        >
          <InputGroup
            rightElement={ lockButton }
            type={ showPassword ? 'text' : 'password' }
            intent={ meta.touched && meta.error ? 'danger' : 'none' } { ...field }/>
        </FormGroup>
      ) }
    </Field>
  );
};
